import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Router } from "@angular/router";
import { QueryModel } from "app/models/queryModel";
import { UserService } from "app/services/user.service";
import { CookieService } from "ngx-cookie-service";
import { ForgotPasswordObject } from '../../models/queryModel';
@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.css"],
})
export class ForgetPasswordComponent implements OnInit {
  accountForm: FormGroup;
  registerForm: FormGroup;
  submitted: boolean = false;
  ForgotPasswordObject: ForgotPasswordObject = new ForgotPasswordObject();

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.accountForm = this._fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  EnableChangePassword() {
    this.ForgotPasswordObject.forgot_password.user_email =
      this.accountForm.value.email;

    this.ForgotPasswordObject.forgot_password.user_email;

    this.userService;
    this.userService.GetMethod(this.ForgotPasswordObject).subscribe((res) => {
      this.cookieService.set("resetEmail", res.body.user_email);
      this.cookieService.set("resetToken", res.body.token);
      Swal.fire({
        icon: "success",
        title: res.body.message,
      });
    });
  }

  onSubmit() {
    this.submitted = true;
  }

  closeModal() {
    this.router.navigate(["/login"]);
  }
}
